module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v14-latin_cyrillic-700.5b27ac3.woff2";